import { render, staticRenderFns } from "./tipHeader.vue?vue&type=template&id=66088614&scoped=true"
import script from "./tipHeader.vue?vue&type=script&lang=js"
export * from "./tipHeader.vue?vue&type=script&lang=js"
import style0 from "./tipHeader.vue?vue&type=style&index=0&id=66088614&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66088614",
  null
  
)

export default component.exports